import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

import { useCart } from '@frontend/storefront/components/cart/cart-context';
import type { CartItem } from '@frontend/storefront/lib/shopify/types';

export function EditItemQuantityButton({
  item,
  type,
}: {
  item: CartItem;
  type: 'plus' | 'minus';
}) {
  const { updateCartItem, isUpdating } = useCart();

  return (
    <button
      type="button"
      disabled={isUpdating || !item.id}
      onClick={() => updateCartItem(item.id!, type)}
      aria-label={
        type === 'plus' ? 'Increase item quantity' : 'Reduce item quantity'
      }
      className={clsx(
        'ease flex h-full max-w-[36px] min-w-[36px] flex-none items-center justify-center rounded-full p-2 transition-all duration-200 hover:opacity-80',
        {
          'ml-auto': type === 'minus',
        },
      )}
    >
      {type === 'plus' ? (
        <PlusIcon className="h-4 w-4" />
      ) : (
        <MinusIcon className="h-4 w-4" />
      )}
    </button>
  );
}
